module.exports = __webpack_public_path__ + "ca47bcac.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/edit_icon.png
// module id = 1894
// module chunks = 1 17 18 19 37